import { RefreshCwIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Props = {
  className?: string
  onRefresh: () => void
}

export function AppUpdateBanner({ className, onRefresh }: Props) {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        'border-border-default fixed inset-x-0 bottom-0 z-50 flex flex-wrap items-center justify-between gap-3 border-t bg-sky-50 px-4 py-3 text-sm text-sky-950 shadow-lg',
        className
      )}
      role='status'
    >
      <p>{t('appUpdate.message')}</p>
      <Button type='button' variant='default' size='sm' onClick={onRefresh}>
        <RefreshCwIcon className='size-4' />
        {t('appUpdate.refresh')}
      </Button>
    </div>
  )
}
